// extracted by mini-css-extract-plugin
module.exports = {"costcoBtn":"costcoOverRide_costcoBtn__1GfGt","costcoDarkBtn":"costcoOverRide_costcoDarkBtn__u7EpT"};